/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type services_ContractDateCalculationMetadata = {
    /**
     * Canton is the Swiss canton code used for kindergarten date calculation (2-letter uppercase)
     * pattern: ^[A-Z]{2}$
     */
    canton?: services_ContractDateCalculationMetadata.canton;
    /**
     * ChildAgeAtKindergarten is the child's age in months when starting kindergarten
     */
    child_age_at_kindergarten?: number;
    /**
     * DaycareMinAgeMonths is the minimum age in months for daycare enrollment
     */
    daycare_min_age_months?: number;
    /**
     * KindergartenMinAgeMonths is the minimum age in months for kindergarten enrollment
     */
    kindergarten_min_age_months?: number;
    /**
     * KindergartenStartDate is the calculated kindergarten start date for the child
     */
    kindergarten_start_date?: string;
};
export namespace services_ContractDateCalculationMetadata {
    /**
     * Canton is the Swiss canton code used for kindergarten date calculation (2-letter uppercase)
     * pattern: ^[A-Z]{2}$
     */
    export enum canton {
        AG = 'AG',
        AI = 'AI',
        AR = 'AR',
        BE = 'BE',
        BL = 'BL',
        BS = 'BS',
        FR = 'FR',
        GE = 'GE',
        GL = 'GL',
        GR = 'GR',
        JU = 'JU',
        LU = 'LU',
        NE = 'NE',
        NW = 'NW',
        OW = 'OW',
        SG = 'SG',
        SH = 'SH',
        SO = 'SO',
        SZ = 'SZ',
        TG = 'TG',
        TI = 'TI',
        UR = 'UR',
        VD = 'VD',
        VS = 'VS',
        ZG = 'ZG',
        ZH = 'ZH',
    }
}

